import React, { useContext, useEffect, useState } from 'react'
import { authContext,setAuthData } from '../../Login/AuthContext';
import AsyncCSV from '../../config/ExportCSV'


var headerHebergements = ["id","name","longitude", "latitude", "Nb rooms", "type", "category", "review score", "cleanliness score", "facilities score", "location score", "Nb reviews", "class"];
var csv_headerHebergements = [
    {label:"id", key:"id"},
    {label:"name", key:"name"},
    {label:"longitude", key:"longitude"},
    {label:"latitude", key:"latitude"},
    {label:"total_number_of_room", key:"total_number_of_room"},
    {label:"type", key:"type"},
    {label:"category", key:"category"},
    {label:"review_score", key:"review_score"},
    {label:"cleanliness_score", key:"cleanliness_score"},
    {label:"facilities_score", key:"facilities_score"},
    {label:"location_score", key:"location_score"},
    {label:"nbReviews", key:"nbReviews"},
    {label:"class", key:"class"}
  ];

const HebergementsTable = () => {
  const { auth } = useContext(authContext);
  const [value, setValue] = useState ();

  if(!value)
       setValue(1)
  useEffect(() => {
    if(auth.data){
      fetch("https://mel.dvrc.fr/api/GetBookingHebergementsByShapeGID36.php?shape_gid="+auth.data.zone.shapes+"&token="+auth.data.token)
        .then(res => res.json())
        .then( (data) => {
            auth.data.hebergements = []
            auth.data.hebergements = data;
            auth.data.dataCSV = toCSV(auth.data.dataCSV, "Hebergements", data)
            if(value < 3)
                setValue(value+1)
      })
    }
    }, [auth.data, value])

  if(!auth.data.zone || !auth.data.hebergements || auth.data.hebergements.length == 0 || !auth.data.dataCSV){// || auth.data.dataCSV["Hebergements"].length == 0
    return (<center><img src="/figs/loading.gif" alt="loading..." /></center>)
  }
  return (
    <div className="xl-container" key="hebergements_container">
         <div className="col" id="hebergements_data">
           <AsyncCSV name={auth.data.zone.name+"_hebergements"} header={csv_headerHebergements} dataCSV="Hebergements"/>
           <table className="table table-bordered" key="testOther">
            {showHeaders()}
              <tbody>{
                auth.data.hebergements.map((h,i) => {
                    return (
                      <tr  className="parent" key={"h_"+i}>
                        {
                          Object.keys(h).map((td, key) => {
                            return (
                              <td key={"h_"+i+"_"+key}>{h[td]}</td>
                            )
                          })
                        }
                      </tr>
                    )
                })}
              </tbody>
           </table>
         </div>
     </div>
  )
  }

export default HebergementsTable;

 function toCSV (dataCSV, csvFile, data) {
     if(!data)
        return;
    if(!dataCSV)
      dataCSV = [];
    if(!dataCSV[csvFile])
      dataCSV[csvFile] = [];
    for(var j=0;j<data.length;j++){
      var d = data[j];

        var found = 0;
        for(var i=0; i<dataCSV[csvFile].length;i++){
            if(dataCSV[csvFile][i].id == d.id)
                found = 1;
        }
        if(!found)
            dataCSV[csvFile].push(d)
    }
    return dataCSV;
  }


function showHeaders (){
  if(headerHebergements.length === 0)
    return ;
  return (
      <thead>
        <tr className="parent" key={"hebergements_headers"}>
          {
            Object.values(headerHebergements).map((key) => {
              return (
                <th key={"hebergements_headers_"+key}>{key}</th>
              )
            })
          }
        </tr>
      </thead>
  )
}
